import { EGetUserStatus } from '../../actions/user';
import { TReduxActions } from '../../types/redux';
import { TUser } from '../../types/user';

export const userInitialState: TUser = {
  isAuthenticated: false,
  userId: undefined,
};

export function userReducer(state: TUser = userInitialState, action: TReduxActions): TUser {
  switch (action.type) {
    case EGetUserStatus.SetUserData: {
      return action.payload;
    }
  }

  return state;
}
